import {
  DateFieldProps,
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
} from '@/components/form-builder/form-builder.types';
import { BehaviorSubject } from 'rxjs';

interface GetCommitteeHistoryFiltersFormObjectProps {
  committeeOptions: SelectOption[];
  selectedCommittee$: BehaviorSubject<SelectOption | undefined>;
  selectedDate$: BehaviorSubject<Date | null>;
}

export const getCommitteeHistoryFiltersFormObject = ({
  committeeOptions,
  selectedCommittee$,
  selectedDate$,
}: GetCommitteeHistoryFiltersFormObjectProps): DynamicForm => {
  const selectCommitteeField: DynamicField<SelectFieldProps> = {
    label: 'settings.committee.filters.committee.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'settings.committee.filters.committee.placeholder',
      value: selectedCommittee$,
      options: committeeOptions,
      filterEnabled: true,
      onSelectChange(event: SelectOption) {
        selectedCommittee$.next(event);
      },
    },
  };

  const dateField: DynamicField<DateFieldProps> = {
    label: 'settings.committee.filters.date.label',
    variant: FieldVariant.DATE,
    props: {
      value: selectedDate$,
      view: 'date',
      lastDate: new Date(), // Disable future dates
      onChange: (date: Date) => {
        selectedDate$.next(date);
      },
    },
  };

  return {
    title: '',
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [selectCommitteeField, dateField],
          },
        ],
      },
    ],
  };
};
